import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const SourceSearch = React.lazy(
  () => import('components/Source/Search/Search'),
);

function ScreensSourceList() {
  return (
    <BaseLayout>
      <DocumentTitle>Source List</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <SourceSearch />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensSourceList;
